import { isNil } from 'lodash';
import Sla from './Sla';

export default class Appointment extends Sla {
  isValid() {
    return !isNil(this.start) && !isNil(this.end) && this.start < this.end;
  }
}
